import { FC, memo } from 'react'
import { Tiny2 } from '@/components/atoms/typography'

type ProductDetailPlainInfoProps = {
  title: string
}

const ProductDetailPlainInfo: FC<ProductDetailPlainInfoProps> = ({ title }) => (
  <>
    <Tiny2 opacity={0.6}>{title}</Tiny2>
  </>
)

export default memo(ProductDetailPlainInfo)
